import {
  SHOW_TAXRECEIPT_FIELD,
  HIDE_TAXRECEIPT_FIELD,
  DOWNLOAD_TAXRECEIPT_START,
  DOWNLOAD_TAXRECEIPT_SUCCESS,
  DOWNLOAD_TAXRECEIPT_ERROR,
  CANCEL_TAXRECEIPT_START,
  CANCEL_TAXRECEIPT_SUCCESS,
  CANCEL_TAXRECEIPT_ERROR,
  REGENERATE_TAXRECEIPT_START,
  REGENERATE_TAXRECEIPT_SUCCESS,
  REGENERATE_TAXRECEIPT_ERROR,
  GENERATE_TAXRECEIPT_START,
  GENERATE_TAXRECEIPT_SUCCESS,
  GENERATE_TAXRECEIPT_ERROR,
  RESEND_TAXRECEIPT_START,
  RESEND_TAXRECEIPT_SUCCESS,
  RESEND_TAXRECEIPT_ERROR,
  FETCH_TAXRECEIPT_LOGS_START,
  FETCH_TAXRECEIPT_LOGS_SUCCESS,
  FETCH_TAXRECEIPT_LOGS_ERROR,
  FETCH_TAXRECEIPT_CONFIGURATION_START,
  FETCH_TAXRECEIPT_CONFIGURATION_SUCCESS,
  FETCH_TAXRECEIPT_CONFIGURATION_ERROR,
  UPDATE_TAXRECEIPT_CONFIGURATION_START,
  UPDATE_TAXRECEIPT_CONFIGURATION_SUCCESS,
  UPDATE_TAXRECEIPT_CONFIGURATION_ERROR,
  FETCH_TAXRECEIPT_CONFIGURATION_LOGS_START,
  FETCH_TAXRECEIPT_CONFIGURATION_LOGS_SUCCESS,
  FETCH_TAXRECEIPT_CONFIGURATION_LOGS_ERROR,
  UI_TAX_RECEIPT_DONATION_CLEAR,

  FETCH_TAX_RECEIPT_PLATFORM_ISSUING_ENABLED_START,
  FETCH_TAX_RECEIPT_PLATFORM_ISSUING_ENABLED_SUCCESS,
  FETCH_TAX_RECEIPT_PLATFORM_ISSUING_ENABLED_ERROR,
  FETCH_TAX_RECEIPT_CAMPAIGN_ISSUING_ENABLED_START,
  FETCH_TAX_RECEIPT_CAMPAIGN_ISSUING_ENABLED_SUCCESS,
  FETCH_TAX_RECEIPT_CAMPAIGN_ISSUING_ENABLED_ERROR,
  UPDATE_TAX_RECEIPT_CAMPAIGN_ISSUING_STATUS_START,
  UPDATE_TAX_RECEIPT_CAMPAIGN_ISSUING_STATUS_SUCCESS,
  UPDATE_TAX_RECEIPT_CAMPAIGN_ISSUING_STATUS_ERROR,
  FETCH_TAX_RECEIPT_CAMPAIGN_ISSUING_STATUS_START,
  FETCH_TAX_RECEIPT_CAMPAIGN_ISSUING_STATUS_SUCCESS,
  FETCH_TAX_RECEIPT_CAMPAIGN_ISSUING_STATUS_ERROR,
  FETCH_TAX_RECEIPT_CAMPAIGN_ISSUING_STATUS_LOGS_START,
  FETCH_TAX_RECEIPT_CAMPAIGN_ISSUING_STATUS_LOGS_SUCCESS,
  FETCH_TAX_RECEIPT_CAMPAIGN_ISSUING_STATUS_LOGS_ERROR,

  UNMOUNT_TAX_RECEIPT
} from './taxReceiptActions';


export const initialState = {
  isDownloadInProgress: false,
  isCancelInProgress: false,
  isRegenerateInProgress: false,
  isGenerateInProgress: false,
  isResendInProgress: false,
  isFetchConfigurationInProgress: false,
  isFetchLogsInProgress: false,
  isUpdateConfigurationInProgress: false,
  taxReceiptConfiguration: {},
  taxReceiptConfigurationLogs: {},
  taxReceiptLogs: {},
  taxReceiptFieldDisplay: false,

  isFechPlaformIssuingEnabledInProgress: false,
  isFechCampaignIssuingEnabledInProgress: false,
  isFechCampaignIssuingStatusInProgress: false,
  isUpdateCampaignIssuingStatusInProgress: false,
  isFechCampaignIssuingStatusLogsInProgress: false,
  plaformIssuingEnabled: false,
  campaignIssuingEnabled: false,
  campaignIssuingStatus: 2,
  campaignIssuingStatusLogs: {}
};

export default function taxReceiptReducer(state = initialState, action) {
  switch (action.type) {
    case SHOW_TAXRECEIPT_FIELD:
      return { ...state, taxReceiptFieldDisplay: true};

    case HIDE_TAXRECEIPT_FIELD:
      return { ...state, taxReceiptFieldDisplay: false};

    case DOWNLOAD_TAXRECEIPT_START:
      return { ...state, isDownloadInProgress: true};

    case DOWNLOAD_TAXRECEIPT_SUCCESS:
    case DOWNLOAD_TAXRECEIPT_ERROR:
      return { ...state, isDownloadInProgress: false};

    case CANCEL_TAXRECEIPT_START:
      return { ...state, isCancelInProgress: true};

    case CANCEL_TAXRECEIPT_SUCCESS:
    case CANCEL_TAXRECEIPT_ERROR:
      return { ...state, isCancelInProgress: false};

    case REGENERATE_TAXRECEIPT_START:
      return { ...state, isRegenerateInProgress: true};

    case REGENERATE_TAXRECEIPT_SUCCESS:
    case REGENERATE_TAXRECEIPT_ERROR:
      return { ...state, isRegenerateInProgress: false};

    case GENERATE_TAXRECEIPT_START:
      return { ...state, isGenerateInProgress: true};

    case GENERATE_TAXRECEIPT_SUCCESS:
    case GENERATE_TAXRECEIPT_ERROR:
      return { ...state, isGenerateInProgress: false};

    case RESEND_TAXRECEIPT_START:
      return { ...state, isResendInProgress: true};

    case RESEND_TAXRECEIPT_SUCCESS:
    case RESEND_TAXRECEIPT_ERROR:
      return { ...state, isResendInProgress: false};

    case FETCH_TAXRECEIPT_LOGS_START:
      return { ...state, isFetchLogsInProgress: true};

    case FETCH_TAXRECEIPT_LOGS_SUCCESS:
      return { ...state, isFetchLogsInProgress: false,
        taxReceiptLogs: action.payload,
      };

    case FETCH_TAXRECEIPT_LOGS_ERROR:
      return { ...state, isFetchLogsInProgress: false,
        taxReceiptLogs: initialState.taxReceiptLogs,
      };

    case FETCH_TAXRECEIPT_CONFIGURATION_START:
      return { ...state, isFetchConfigurationInProgress: true};

    case FETCH_TAXRECEIPT_CONFIGURATION_SUCCESS:
      return { ...state, isFetchConfigurationInProgress: false,
        taxReceiptConfiguration: action.payload,
      };

    case FETCH_TAXRECEIPT_CONFIGURATION_ERROR:
      return { ...state, isFetchConfigurationInProgress: false,
        taxReceiptConfiguration: initialState.taxReceiptConfiguration,
      };

    case UPDATE_TAXRECEIPT_CONFIGURATION_START:
      return { ...state, isUpdateConfigurationInProgress: true};

    case UPDATE_TAXRECEIPT_CONFIGURATION_SUCCESS:
      return { ...state, isUpdateConfigurationInProgress: false};

    case UPDATE_TAXRECEIPT_CONFIGURATION_ERROR:
      return { ...state, isUpdateConfigurationInProgress: false};

    case FETCH_TAXRECEIPT_CONFIGURATION_LOGS_START:
      return { ...state, isFetchConfigurationLogsInProgress: true};

    case FETCH_TAXRECEIPT_CONFIGURATION_LOGS_SUCCESS:
      return { ...state, isFetchConfigurationLogsInProgress: false,
        taxReceiptConfigurationLogs: action.payload,
      };

    case FETCH_TAXRECEIPT_CONFIGURATION_LOGS_ERROR:
      return { ...state, isFetchConfigurationLogsInProgress: false,
        taxReceiptConfigurationLogs: initialState.taxReceiptConfigurationLogs,
      };

    case FETCH_TAX_RECEIPT_PLATFORM_ISSUING_ENABLED_START:
      return { ...state, isFechPlaformIssuingEnabledInProgress: true };

    case FETCH_TAX_RECEIPT_PLATFORM_ISSUING_ENABLED_SUCCESS:
      return { ...state, isFechPlaformIssuingEnabledInProgress: false,
        plaformIssuingEnabled: action.payload.enabled,
      };

    case FETCH_TAX_RECEIPT_PLATFORM_ISSUING_ENABLED_ERROR:
      return { ...state, isFechPlaformIssuingEnabledInProgress: false,
        plaformIssuingEnabled: initialState.plaformIssuingEnabled,
      };

    case FETCH_TAX_RECEIPT_CAMPAIGN_ISSUING_ENABLED_START:
      return { ...state, isFechCampaignIssuingEnabledInProgress: true };

    case FETCH_TAX_RECEIPT_CAMPAIGN_ISSUING_ENABLED_SUCCESS:
      return { ...state, isFechCampaignIssuingEnabledInProgress: false,
        campaignIssuingEnabled: action.payload.enabled,
      };

    case FETCH_TAX_RECEIPT_CAMPAIGN_ISSUING_ENABLED_ERROR:
      return { ...state, isFechCampaignIssuingEnabledInProgress: false,
        campaignIssuingEnabled: initialState.campaignIssuingEnabled,
      };

    case FETCH_TAX_RECEIPT_CAMPAIGN_ISSUING_STATUS_START:
      return { ...state, isFechCampaignIssuingStatusInProgress: true };

    case FETCH_TAX_RECEIPT_CAMPAIGN_ISSUING_STATUS_SUCCESS:
      return { ...state, isFechCampaignIssuingStatusInProgress: false,
        campaignIssuingStatus: action.payload.statusId,
      };

    case FETCH_TAX_RECEIPT_CAMPAIGN_ISSUING_STATUS_ERROR:
      return { ...state, isFechCampaignIssuingStatusInProgress: false,
        campaignIssuingStatus: initialState.campaignIssuingStatus,
      };

    case UPDATE_TAX_RECEIPT_CAMPAIGN_ISSUING_STATUS_START:
      return { ...state, isUpdateCampaignIssuingStatusInProgress: true };

    case UPDATE_TAX_RECEIPT_CAMPAIGN_ISSUING_STATUS_SUCCESS:
      return { ...state, isUpdateCampaignIssuingStatusInProgress: false,
        campaignIssuingStatus: action.payload.statusId,
      };

    case UPDATE_TAX_RECEIPT_CAMPAIGN_ISSUING_STATUS_ERROR:
      return { ...state, isUpdateCampaignIssuingStatusInProgress: false,
        campaignIssuingStatus: initialState.campaignIssuingStatus,
      };

    case FETCH_TAX_RECEIPT_CAMPAIGN_ISSUING_STATUS_LOGS_START:
      return { ...state, isFechCampaignIssuingStatusLogsInProgress: true };

    case FETCH_TAX_RECEIPT_CAMPAIGN_ISSUING_STATUS_LOGS_SUCCESS:
      return { ...state, isFechCampaignIssuingStatusLogsInProgress: false,
        campaignIssuingStatusLogs: action.payload,
      };

    case FETCH_TAX_RECEIPT_CAMPAIGN_ISSUING_STATUS_LOGS_ERROR:
      return { ...state, isUpdateCampaignIssuingStatusInProgress: false,
        campaignIssuingStatusLogs: initialState.campaignIssuingStatusLogs,
      };

    case UI_TAX_RECEIPT_DONATION_CLEAR:
      return initialState;

    case UNMOUNT_TAX_RECEIPT:
      return {};

    default:
      return state;
  }
}
